import type { GraphEdgeKind } from "../model/workflowGraph";

/**
 * What each kind of edge means (P-14, design D14; F40, R-10), in one place: the canvas
 * draws its edges with `EdgeLine`, and the legend draws its samples with the same
 * component, in the read view and the editor alike. The strokes are
 * `app-flow-edge-<kind>` in `workflow-graph.css`.
 */
export interface EdgeKindStyle {
  /** `workflows.legend.samples.<…>`: the legend's words for the line. */
  readonly sample: "passesResult" | "readsSaved" | "then";
}

export const EDGE_KINDS: Readonly<Record<GraphEdgeKind, EdgeKindStyle>> = {
  step_result: { sample: "passesResult" },
  read: { sample: "readsSaved" },
  then: { sample: "then" },
};

/** The legend's order: a step's result first, then reads, then "then". */
export const EDGE_KIND_ORDER: readonly GraphEdgeKind[] = ["step_result", "read", "then"];

/** One arrowhead for every edge, in graph pixels: the direction, nothing more (R-10). */
export const ARROWHEAD = { length: 8, width: 8 } as const;

/** A `then` into a step that waits for Run is dotted, as the step's chip says. */
export function edgeClassName(kind: GraphEdgeKind, waitsForRun: boolean): string {
  return `app-flow-edge app-flow-edge-${kind}${kind === "then" && waitsForRun ? " app-flow-edge-optional" : ""}`;
}
